import emrService from '@/apis/emr/service';
import EmrSelect from '@/screens/CreateEmr/EmrInput/EmrSelect';
import RecursivelyCreateForm from '@/screens/CreateEmr/RecursivelyCreateForm';
import useCreateEmr from '@/screens/CreateEmr/store';
import useGlobalConfigs from '@/stores/globalConfigs';
import quickModal, { IQuickModalResult, useQuickModalContext } from '@/utils/quickModal';
import { Button, Form, Input, Row } from 'antd';
import _ from 'lodash';
import * as React from 'react';
import { useParams } from 'react-router-dom';
export interface IFormCreateEmrProps {
  initValues?: IEMRData;
  emrTypeStringInit?: string;
  disabled?: boolean;
  onOk?: (_: IQuickModalResult, data?: any) => void;
  onCancel?: (_: IQuickModalResult) => void;
}

export default function FormCreateEmr({
  initValues,
  emrTypeStringInit,
  disabled,
  onOk: onOK,
  onCancel,
  ...props
}: IFormCreateEmrProps) {
  const [form] = Form.useForm();
  const [emrTypeString, setEmrType] = React.useState<string>(emrTypeStringInit || '');
  const getListCreateEMRs = useGlobalConfigs((s) => s.getListCreateEMRs);
  const emrTypes = useGlobalConfigs((s) => s.emrTypes);
  const emrType = emrTypes?.[emrTypeString];
  const listEmrType = getListCreateEMRs();
  const params = useParams();
  const uid = params.uid as string;
  const { mutate } = emrService.useUpsert();
  const { modal } = useQuickModalContext();
  const setIsFormChange = useCreateEmr((s) => s.setIsFormChange);
  const isFormChange = useCreateEmr((s) => s.isFormChange);
  const refetchPHR = useGlobalConfigs((s) => s.refetchPHR);
  const refetchTimeline = useGlobalConfigs((s) => s.refetchTimeline);
  const refetchBody = useGlobalConfigs((s) => s.refetchBody);
  const refetchCountBody = useGlobalConfigs((s) => s.refetchCountBody);
  // Fix bug data tạm thời
  if (initValues && _.isArray(initValues.data)) {
    initValues.data = {};
  }

  React.useEffect(() => {
    modal.confirmHandler = isFormChange
      ? async () => {
          const result = await quickModal.confirm({ content: 'Bạn có chắc chắn muốn đóng không?' });
          if (result) setIsFormChange(false);
          return result;
        }
      : undefined;
  }, [isFormChange, modal, setIsFormChange]);

  const onSubmit = () => {
    const raw = form.getFieldsValue(true);
    const data = convertDataRecursive(raw);

    data.data = data.data ?? {};
    console.log('FINISH: ', data);

    const payload = {
      ...data,
      uid,
      type: emrTypeString,
      tags: data.tags,
      _id: initValues?._id,
    };

    mutate(payload, {
      onSuccess(data: any) {
        setIsFormChange(false);
        modal.confirmHandler = undefined;
        onOK ? onOK(modal, data) : modal.close();
        refetchPHR?.();
        refetchTimeline?.();
        refetchBody?.();
        refetchCountBody?.();
      },
    });
  };

  return (
    <>
      {emrTypeStringInit ? (
        ''
      ) : (
        <EmrSelect
          labelProps={{ required: true, className: 'px-4', label: 'Loại', labelCol: { span: 24 } }}
          name={'selectType'}
          onChange={async (value) => {
            if (!isFormChange || (await quickModal.confirm({}))) {
              form.resetFields();
              setIsFormChange(false);
              setEmrType(value);
            }
          }}
          options={listEmrType?.map((d: any) => ({
            label: d?.name,
            value: d?.code,
          }))}
          placeholder="Chọn EMR"
          showSearch={true}
          filterOption={(input: any, option: any) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          allowClear
        />
      )}

      <Form
        scrollToFirstError
        initialValues={initValues}
        onValuesChange={() => setIsFormChange(true)}
        disabled={disabled}
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item name={'_id'} hidden>
          <Input />
        </Form.Item>
        <Row gutter={[8, 0]} className="px-4">
          <RecursivelyCreateForm
            emrType={emrType}
            fields={emrType?.format?.fields}
            disabled={disabled}
            isEdit={!disabled && !!initValues}
          />
        </Row>
        {emrTypeString && !disabled && (
          <div className="flex mt-8 px-2 sticky bottom-0 left-0 w-full bg-quick-modal p-4 rounded-lg">
            <Form.Item className="w-1/2 pr-2 mb-0">
              <Button
                className="w-full"
                htmlType="button"
                onClick={async () => {
                  onCancel ? onCancel(modal) : modal.close();
                }}
              >
                Đóng
              </Button>
            </Form.Item>

            <Form.Item className="w-1/2 mb-0">
              <Button type="primary" className="w-full  text-white" onClick={form.submit}>
                Lưu
              </Button>
            </Form.Item>
          </div>
        )}
      </Form>
    </>
  );
}

export const convertDataRecursive = (data: any) => {
  const handler = (iData: any) => {
    const iResult: any = {};
    for (const key in iData) {
      // Xóa type và user trong dữ liệu vì 2 thành phần này không được cập nhật
      if (['type', 'user'].includes(key) && iData['data'] && iData[key]?._id) {
        delete iData[key];
      }

      if (key === 'tags') {
        iResult[key] = iData[key];
        continue;
      }

      if (JSON.stringify(iData[key]) === '[{}]' || JSON.stringify(iData[key]) === '[{}]') {
        delete iData[key];
      }

      if (_.isPlainObject(iData[key]) && iData[key] && !_.isArray(iData[key])) {
        iResult[key] = handler(iData[key]);
      } else if (_.isArray(iData[key])) {
        iResult[key] = iData[key].map((item: any) => handler(item));
      } else {
        iResult[key] = iData[key];
      }

      if (key === 'data' && iResult[key]) {
        if (_.isEmpty(iResult[key])) {
          delete iResult[key];
        }
      }
    }
    return iResult;
  };

  return handler(cleanDeep(data));
};

function cleanDeep(obj: any) {
  // Loại bỏ các giá trị null, undefined và chuỗi rỗng
  if (obj === null || obj === undefined || (typeof obj === 'string' && obj.trim() === '')) {
    return undefined;
  }

  // Xử lý mảng
  if (Array.isArray(obj)) {
    const cleanedArray: any = obj.map((item) => cleanDeep(item)).filter((item) => item !== undefined);
    return cleanedArray.length > 0 ? cleanedArray : undefined;
  }

  // Xử lý đối tượng
  if (_.isPlainObject(obj)) {
    Object.keys(obj).forEach((key) => {
      const value = cleanDeep(obj[key]);
      if (value === undefined) {
        delete obj[key];
      } else {
        obj[key] = value;
      }
    });

    // Kiểm tra nếu đối tượng rỗng sau khi đã xử lý
    if (Object.keys(obj).length === 0) {
      return undefined;
    }
  }

  return obj;
}
